import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";

import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";

const DeviceFormStepTwo = (props) => {
  const { t } = useTranslation();

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:device.more")} />
      <Row>
        <Col xs={12}>
          <Field
            name="comments"
            label={`${t("global:device.more")}`}
            component={BMXTextField}
            data-cy="comments"
            maxRows={4}
            multiline={true}
          />
        </Col>
      </Row>
    </div>
  );
};

export default DeviceFormStepTwo;
